import styled from "styled-components";
import { toAbsoluteUrl } from "../../../utils/assetHelper";

export const Wrapper = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    backdrop-filter: blur(5px);
    z-index: 100 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    background: url(${toAbsoluteUrl('/media/bulkorderbg.jpg')}) no-repeat;
    background-size: cover;
    background-position: center left;

    .close{
        color: #fff !important;
        position: absolute;
        right: 32px;
        top: 32px;
        cursor: pointer;
        z-index: 9;
        font-size: 25px;
    }

    .bulk-order-modal-content {
        position: relative;
        height: max-content;
        width: 100%;
        height: 100%;
        padding: 120px 6rem 90px 6rem;

    @media screen and (max-width: 1100px) {
        width: 95vw;
        padding: 90px 1.2rem 90px 1.2rem;
    }
}
`

export const ContactWrapper = styled.div`    
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    height: 100%;
    width: 100%;
    

    @media screen and (max-width: 1100px) {
        flex-direction: column;
        gap: 50px;

        .left-container {
            width: 100% !important;
        }

        .right-container {
            display: block;
            width: 100% !important;
        }

    }


    @media screen and (min-width: 2160px) {
        padding-left: 25rem;
        padding-right: 25rem;

    }


    .left-container {
        width: 45%;

        .solutions-text {
            h2 {
                color: var(--white);
                font-size: 48px;
                font-weight: 700;
                margin-bottom: 12px;
                text-align: left;

                span {
                    color: var(--primary-color)
                }

                @media screen and (max-width: 1100px) {
                    text-align: center;
                }

            }

            p {
                color: #fcfcfc;
                margin-top: 2px;
                font-size: 16px;
                line-height: 24px;
                width: 70%;
                text-align: left;

                @media (max-width: 1100px) {
                    width: 100%;
                    text-align: center;
                }
            }
        }
    }

    .right-container {
        width: 55%;

        .form-container {
            width: 100%;
            height: max-content;
            border-radius: 16px;
            background: rgba(252, 252, 252, 0.92);
            backdrop-filter: blur(18px);
            padding: 24px;
            

            @media (max-width: 1100px) {
                width: 100%;
                height: max-content;
                margin-bottom: 60px;

                .btn {
                    float: none !important;
                }
            }

            .two-column {
                display: flex;
                justify-content: space-between;
                gap: 20px;
                margin-bottom: 20px;

                @media (max-width: 1000px) {
                    flex-direction: column;
                }
            }

            .three-column {
                display: flex;
                justify-content: space-between;
                gap: 20px;
                margin-bottom: 20px;

                @media screen and (max-width: 1000px) {
                    flex-direction: column;
                }

                .phone-number-div {
                    width: 50%;
                    transform: translateY(-5px);

                    @media screen and (max-width: 1000px) {
                        width: 100%;
                    }
                }

                .two-column {
                    display: flex;
                    width: 50%;
                    justify-content: space-between;
                    gap: 20px;
                    margin-bottom: 0px !important;

                    @media (max-width: 1000px) {
                        flex-direction: column;
                        width: 100%;
                    }
                }
            }

            select {
                border-radius: 12px;
                border: 1px solid #F1EEFC;
                background: #FCFCFC;
                backdrop-filter: blur(19px);
                display: flex;
                height: 48px;
                padding: 10px 12px;
                outline: unset !important;
                border: unset !important;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #28272e;
                width: 100%;

                @media (max-width: 768px) {
                    width: -webkit-fill-available;
                }

                @media (max-width: 1000px) {
                    width: -webkit-fill-available;
                }

                -moz-appearance: none;
                -webkit-appearance: none;
                appearance: none;
                background-image: url(${toAbsoluteUrl("/media/angle-down.png")});
                background-repeat: no-repeat,
                repeat;
                background-position: right 0.7em top 50%,
                0 0;
                background-size: 0.65em auto,
                100%;
            }

            textarea {
                width: 100%;
                height: 90px;
                color: #7d8ca5;
                font-weight: 400;
                padding: 10px 12px;
                outline: unset !important;
                /* overflow: hidden; */
                border-radius: 12px;
                border: 1px solid #F1EEFC;
                background: #FCFCFC;
                backdrop-filter: blur(19px);
                color: #28272E;
                text-overflow: ellipsis;
                /* white-space: nowrap; */

                :focus-visible {
                    outline: unset !important;
                }

                &::placeholder {
                    color: #9a9a9a;
                    font-family: "Inter";
                    font-style: normal;
                    font-size: 14px;
                    line-height: 20px;
                    opacity: 1;
                }

                @media (max-width: 1000px) {
                    height: 140px !important;
                }
            }

        }
    }


`
